module.exports = __webpack_public_path__ + "static/media/21.c2a5dcb1.webp";